import { TableColumn } from '@/components/new/table/DataTable'
import { IDocument } from '../../../interfaces/interfaces'

export const columns: TableColumn<IDocument>[] = [
  {
    accessorKey: 'name',
    header: 'Nombre',
    cell: ({ row }) => {
      return <p className={'py-1 font-medium'}>{row.original.name || '-'}</p>
    },
  },
  {
    accessorKey: 'observations',
    header: 'Observaciones',
    cell: ({ row }) => {
      return (
        <div className="flex justify-center">
          <p className={`max-w-28 py-1 text-left font-medium`}>
            {row.original.observations || '-'}
          </p>
        </div>
      )
    },
  },
]
